import { FC, ReactNode, useMemo } from 'react'

import { Progress, Spinner } from '@agro-club/agroclub-shared'

import { DocumentType } from 'modules/domain/types'
import FileItem from 'views/components/FilesByTypes/FileItem'
import { FilesLayout, Loading } from 'views/components/FilesByTypes/styled'
import FilesGroupModal from './FilesGroupModal'
import { refetchFunc } from 'modules/domain/common/hooks'
import { DriverDocumentFile } from 'views/pages/LogisticsKR/types'
import { DriverExtraFileInfo } from './DriverExtraFileInfo'

export interface InternalDriverFilesByTypesProps {
  types: DocumentType[]
  files: DriverDocumentFile[]
  description?: Record<string, ReactNode>
  uploadUrl: string
  loading?: boolean
  deleteProgress?: Progress
  refetch: refetchFunc
  onDelete?: (document_id: string) => void
  maxWidth?: number
  readOnly?: boolean
}

const InternaFilesByTypesModal: FC<InternalDriverFilesByTypesProps> = ({
  types = [],
  files = [],
  refetch,
  onDelete,
  loading,
  deleteProgress,
  description,
  uploadUrl,
  maxWidth,
  readOnly,
}) => {
  const tree = useMemo(
    () =>
      types.map((type) => ({
        ...type,
        files: files.filter((file) => file.document_type === type.slug),
      })),
    [types, files],
  )

  return (
    <FilesLayout>
      {loading && (
        <Loading>
          <Spinner />
        </Loading>
      )}

      {tree.map((item) => (
        <FilesGroupModal
          key={item.slug}
          header={item.label}
          refetch={refetch}
          description={description?.[item.slug] ?? ''}
          documentType={item.slug}
          uploadUrl={uploadUrl}
          maxWidth={maxWidth}
          allowAdd={!readOnly}
        >
          {item.files.length > 0 &&
            item.files.map((file) => (
              <FileItem
                key={file.id}
                file={file}
                onDelete={readOnly ? undefined : onDelete}
                progress={deleteProgress}
                extraContent={<DriverExtraFileInfo file={file} />}
              />
            ))}
        </FilesGroupModal>
      ))}
    </FilesLayout>
  )
}

export default InternaFilesByTypesModal
